import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './styles/index.css'
import { CartProvider } from './context/CartContext.jsx'
import './i18n'
import { ShopLangProvider } from './context/ShopLangContext.jsx'
import ShopLangToggle from './components/common/ShopLangToggle.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <ShopLangProvider>
          <App />
          <ShopLangToggle />
        </ShopLangProvider>
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
)
